// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"232c9a81","453":"6e329848","455":"6c7029b1","977":"a2dfd7dd"}[chunkId] + ".chunk.js";
};